import { NOT_AVAILABLE } from 'constants/text';
var VehicleSize;
(function (VehicleSize) {
  VehicleSize["Heavy"] = "vehicles.heavy";
  VehicleSize["Regular"] = "vehicles.regular";
})(VehicleSize || (VehicleSize = {}));
const getVehicleSizeTranslation = input => {
  if (!input) return NOT_AVAILABLE;
  return VehicleSize[input];
};
export default getVehicleSizeTranslation;